// Application-wide constants
// This file centralizes all magic numbers and configuration values

// API Configuration
export const API_CONFIG = {
  TIMEOUT: 30000, // 30 seconds
  REQUEST_TIMEOUT: 30000,
};

// File Upload Configuration
export const FILE_UPLOAD = {
  MAX_SIZE: 5 * 1024 * 1024, // 5MB in bytes
  MAX_IMAGE_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/jpg'],
  ALLOWED_IMAGE_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.gif', '.webp'],
};

// Cache Configuration
export const CACHE_CONFIG = {
  DEFAULT_TTL: 5 * 60 * 1000, // 5 minutes
  DROPDOWN_TTL: 10 * 60 * 1000, // 10 minutes
  PRODUCTS_TTL: 2 * 60 * 1000, // 2 minutes
};

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 25,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
};

// Debounce delays
export const DEBOUNCE = {
  SEARCH_DELAY: 500, // milliseconds
  DEFAULT_DELAY: 300,
};
